import { render, staticRenderFns } from "./gis.vue?vue&type=template&id=0a228cb4&scoped=true&"
import script from "./gis.vue?vue&type=script&lang=js&"
export * from "./gis.vue?vue&type=script&lang=js&"
import style0 from "./gis.vue?vue&type=style&index=0&id=0a228cb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a228cb4",
  null
  
)

export default component.exports